import { ResponseError } from '@marketplace-web/core-api/api-client-util'
import { BundlingLimitationsErrorType } from '@marketplace-web/bundles/items-bundle-data'
import {
  CurrencyAmountDto,
  CurrencyAmountModel,
  transformCurrencyAmountDto,
} from '@marketplace-web/currency/currency-data'

const resolveBundleLimit = (limit?: CurrencyAmountDto | null): CurrencyAmountModel | null => {
  if (!limit) return null

  if ('amount' in limit && 'currency_code' in limit) {
    return transformCurrencyAmountDto(limit)
  }

  return null
}

export const resolveBundleError = (response: ResponseError) => {
  const { message_code, payload } = response

  switch (message_code) {
    case BundlingLimitationsErrorType.BundleExceedsLimit:
      return {
        limit: resolveBundleLimit(payload?.limit),
        type: BundlingLimitationsErrorType.BundleExceedsLimit,
      }

    case BundlingLimitationsErrorType.ItemExceedsLimit:
      return {
        limit: resolveBundleLimit(payload?.limit),
        type: BundlingLimitationsErrorType.ItemExceedsLimit,
      }
    default:
      return null
  }
}
